import { Navigate } from "react-router-dom";
import { useEndUser } from "@/contexts/EndUserContext";
import Index from "./Index";

/** Players land on their recruiting portfolio; coach home remains unchanged. */
export default function HomeRoute() {
  const { userType } = useEndUser();
  return userType === "coach" ? <Index /> : <Navigate to="/pipeline" replace />;
}
